// PRD 16 P6 (sportya-web, Tudor 2026-10-24, variant B on the canvas „P6 · Suprafața plutitoare”): react-select's list takes the
// one floating surface of the platform — white, a 1 px border in the Sportya fields' colour (#78ADAB), 10 px corners, its
// shadow — the same values as the design system's FLOATING_SURFACE_STYLE (sportya-design), which the CP does not consume.
// The active option is the design system's turquoise instead of react-select's blue. The control (the field) is untouched.
export const FLOATING_SURFACE_STYLE = {
  background: "#FFFFFF",
  border: "1px solid #78ADAB",
  borderRadius: 10,
  boxShadow: "0px 8px 24px 0px rgba(16, 36, 44, 0.16)",
}

const ACTIVE = "#EAF6F6"
const INK = "#10242C"

// A caller's own `styles` stay theirs; the surface goes on top of its menu, the turquoise on its options.
export const withFloatingSurface = (styles = {}) => ({
  ...styles,
  menu: (base, state) => ({ ...(styles.menu ? styles.menu(base, state) : base), ...FLOATING_SURFACE_STYLE, overflow: "hidden" }),
  option: (base, state) => {
    const own = styles.option ? styles.option(base, state) : base
    if (!state.isFocused && !state.isSelected) return own
    return { ...own, backgroundColor: ACTIVE, color: INK }
  },
})
